import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { adminTemplateTableRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: adminTemplateTableRow[];
  loading?: boolean;
};

const AdminTemplateTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "version",
        label: t("ADMIN_TEMPLATE.TABLE.VERSION"),
        minWidth: 80,
        align: "right",
      },
      {
        id: "lastUpdate",
        label: t("ADMIN_TEMPLATE.TABLE.LAST_UPDATE"),
        minWidth: 130,
        align: "right",
      },
      {
        id: "format",
        label: t("ADMIN_TEMPLATE.TABLE.FORMAT"),
        minWidth: 100,
        align: "right",
      },
      {
        id: "templateDescription",
        label: t("ADMIN_TEMPLATE.TABLE.DESCRIPTION"),
        minWidth: 300,
        align: "right",
        format: (row) => row.templateDescription,
      },
      {
        id: "documentName",
        label: t("ADMIN_TEMPLATE.TABLE.TEMPLATE_NAME"),
        minWidth: 200,
        align: "right",
        format: (row) => row.documentName,
      },
      {
        id: "templateCode",
        label: t("ADMIN_TEMPLATE.TABLE.TEMPLATE_ID"),
        minWidth: 120,
        align: "right",
      },
    ],
    [t],
  );

  return (
    <div className={styles.root}>
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading}
        serialEnabled={false}
        isPointerCursor
      />
    </div>
  );
};

export default AdminTemplateTable;
